import { useEffect } from 'react';
import { useStore } from '@store/appStore';

// Console helpers for checking the prompt bars without waiting for a release or an expiring token:
//   attenderDebug.showSessionExpired()  - the "session expired, sign in again" bar (needs a signed-in user)
//   attenderDebug.showNewVersion()      - the "new version available" bar
//   attenderDebug.hidePrompts()
// They only flip the same store flags the real logic sets, so it's the real component (and the real
// buttons: popup sign-in / reload). Dev site and local only - and harmless if it ever showed up
// elsewhere: it only shows the bars in the user's own browser.
const DEBUG_HOSTS = ['dev.attender.dk', 'localhost', '127.0.0.1'];

export function isDebugEnvironment(hostname: string = typeof window !== 'undefined' ? window.location.hostname : ''): boolean {
  return process.env.ENV === 'DEV' || DEBUG_HOSTS.includes(hostname);
}

export function useDebugTools() {
  useEffect(() => {
    if (!isDebugEnvironment()) return;
    const { setSessionExpired, setNewVersionAvailable } = useStore.getState();
    (window as any).attenderDebug = {
      showSessionExpired: () => setSessionExpired(true),
      showNewVersion: () => setNewVersionAvailable(true),
      hidePrompts: () => {
        setSessionExpired(false);
        setNewVersionAvailable(false);
      },
    };
    return () => {
      delete (window as any).attenderDebug;
    };
  }, []);
}

export default useDebugTools;
